import { parsePhone, ParsePhoneReturn } from '../utilities/phone/parse';

export class PhoneUtilityHandler {
    private _parse: ParsePhoneReturn;

    constructor() {
        this._parse = parsePhone();
    }

    get parse(): ParsePhoneReturn {
        return this._parse;
    }
}
